import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const SearchInput = styled.div<{disabled?, isMobile}>(
  ({ disabled, isMobile }) => `
  margin: 0;
  font-size: 12px;
  margin-left: ${isMobile ? '0px' : '16px'};
  color: #000;
  border: 1px solid ${disabled ? colors.text['sub-300'] : '#BABABA'};
  border-radius: 8px;
  box-sizing: border-box !important;
  display: inline-flex;
  background-color: #fff;
  height: 33px;
  width: ${isMobile ? '100%' : '383px'};
  padding: 3px;
  svg {
    margin: 0px 5px;
  }
  &:focus-within {
    border-left: 1px solid ${colors.Blue300};
    border-right: 1px solid ${colors.Blue300};
    border-top: 1px solid ${colors.Blue300};
  }
  @media (max-width: 1095px) {
    width: ${isMobile ? '100%' : '351px'};
  }
`,
);

export const ContainerItemSelect = styled.div`
  padding-right: 8px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  &:hover {
    background-color: ${colors.brand.primary.lighter};
  }
  margin: 5px 0px 10px 0px;
  cursor: pointer;
  div {
    display: flex;
    gap: 5px;
    align-items: center;
    span {
      margin-bottom: 0px;
      margin-top: 2px;
      max-width: 88%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  svg {
    flex-shrink: 0;
  }

  @media (max-width: 765px) {
    gap: 8px;
  }
`;

export const ContainerSelect = styled.div<{ isMobile?: boolean }>(
  ({ isMobile }) => `
  position: absolute;
  top: 27px;
  left: ${isMobile ? '0' : '16px'};
  width: ${isMobile ? '100%' : '383px'};
  background-color: #fff;
  border: 1px solid ${colors.Blue300};
  border-top: none;
  border-radius: 0 0 6px 6px;
  z-index: 10;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  p {
    color: ${colors.text['sub-500']};
    margin-bottom: 0;
    font-size: 11px;
  }
  h1 {
    font-size: 11px;
    position: fixed;
    bottom: 0;
    background-color: white;
    width: 90%;
    height: 20px;
  }
  @media (max-width: 1095px) {
    width: ${isMobile ? '100%' : '351px'};
  }
`,
);

export const FavoriteButton = styled.div<{ isFavorite?: boolean }>(
  ({ isFavorite }) => `
    cursor: pointer;
    svg path {
      transition: stroke 0.2s, fill 0.2s;
      stroke: ${isFavorite ? colors.Blue300 : colors.text['soft-400']};
      fill: ${isFavorite ? colors.Blue300 : 'none'};
    }

    &:hover span {
      visibility: visible;
      opacity: 1;
    }

    &:hover svg path {
      stroke: ${colors.Blue300};
      fill: #363bc448;
    }
  `,
);

export const TooltipText = styled.span`
  visibility: hidden;
  opacity: 0;
  background-color: #20232D;
  color: #fff;
  text-align: center;
  padding: 3px 6px;
  border-radius: 6px;
  position: absolute;
  bottom: -18px;
  right: 0;
  /* transform: translateX(-50%); */
  white-space: nowrap;
  font-size: 11px;
  transition: opacity 0.2s ease;
  z-index: 12;
`;

export const TooltipUnitText = styled.p<{length: number}>(
  ({ length }) => `
    visibility: hidden;
    opacity: 0;
    white-space: pre-wrap;
    width: 200px;
    color: #fff;
    background-color: #20232D;
    color: #fff;
    text-align: center;
    padding: 3px 6px;
    border-radius: 6px;
    position: absolute;
    top: 100%;
    right: 15%;
    font-size: 11px;
    transition: opacity 0.2s ease;
    z-index: 12;
`,
);

export const TooltipContainer = styled.div`
  &:hover p {
    visibility: visible;
    opacity: 1;
    color: white;
  }

  @media (max-width: 765px) {
    flex: 1 1 auto;
    overflow: hidden;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;

    & > div {
      width: 100%;
    }

    & > span {
      width: 100%;
      max-width: 100%;
    }
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  @media (max-width: 765px) {
    flex: 0 0 30px;
  }
`;

export const ContainerArea = styled.div`
  width: 383px;
  padding-bottom: 3px;
  min-width: 80px;
  display: flex;
  align-items: center;
  margin-top: 3px;
`;

export const StickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  background-color: white;
  padding: 5px 0px;
  z-index: 1;
  font-size: 11px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
  text-align: center;
`;

export const TextInformation = styled.div`
  p {
    font-size: 14px;
    color: ${colors.text['main-900']};
  }
  span {
    font-size: 12px;
    color: ${colors.text['sub-500']};
  }

`;

export const ScrollableOptions = styled.div`
  height: 250px;
  padding-bottom: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  /* Chrome, Edge, Safari */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.Blue300};
    border-radius: 20px; /* arredondamento da alça */
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-button {
    display: none; /* remove as setas */
    height: 0;
    width: 0;
  }

  /* Firefox */
  scrollbar-color: ${colors.Blue300} transparent; /* thumb e track */
  scrollbar-width: thin;
`;
